import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  metaKeySelector,
  setMetaKey,
  setSuperBatches,
  superBatchesSelector,
} from 'features/superBatchManagement';
import Field from 'components/Field';
import InputRenderer from './InputRenderer';
import Select from 'components/Select';
import SuperBatchSelect from 'components/SuperBatchSelect';
import styles from './SuperBatchUpdateMetaPage.module.scss';
import SubmitButton from './SubmitButton';

const META_KEY_DATA = [
  { label: 'Ribbon Data', value: 'ribbon_data' },
  { label: 'Course Pause', value: 'future_dated_pause_request_enabled' },
  { label: 'Course Reset', value: 'back_dated_pause_request_enabled' },
];

function SuperBatchUpdateMetaPage() {
  const dispatch = useDispatch();
  const metaKey = useSelector(metaKeySelector);
  const superBatches = useSelector(superBatchesSelector);

  const excludedSuperBatchIds = useMemo(
    () => superBatches.map((o) => o.value),
    [superBatches]
  );

  const handleSuperBatchChange = useCallback(
    (value) => {
      dispatch(setSuperBatches(value));
    },
    [dispatch]
  );

  const handleMetaKeyChange = useCallback(
    (option) => {
      dispatch(setMetaKey(option));
    },
    [dispatch]
  );

  return (
    <div className={styles.root}>
      <Field
        label="Select super batches to update."
        className={styles.select}
      >
        <SuperBatchSelect
          isMulti
          excludedSuperBatchIds={excludedSuperBatchIds}
          onChange={handleSuperBatchChange}
          value={superBatches}
        />
      </Field>
      <Field
        label="Select key to update."
        className={styles.select}
      >
        <Select
          className={styles.ribbonType}
          placeholder="meta key name"
          value={metaKey}
          options={META_KEY_DATA}
          onChange={handleMetaKeyChange}
        />
      </Field>
      <InputRenderer />
      <SubmitButton />
    </div>
  );
}

export default SuperBatchUpdateMetaPage;
